import { render, staticRenderFns } from "./DistributionChannel.vue?vue&type=template&id=5a346cbe"
import script from "./DistributionChannel.vue?vue&type=script&lang=js"
export * from "./DistributionChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports